import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const HelpGlyph = /*#__PURE__*/createElement("g", {
  id: "help"
}, /*#__PURE__*/createElement("path", {
  d: "M42,18c13.2,0,24,10.8,24,24S55.2,66,42,66S18,55.2,18,42S28.8,18,42,18 M42,15c-14.9,0-27,12.1-27,27s12.1,27,27,27 s27-12.1,27-27S56.9,15,42,15L42,15z"
}), /*#__PURE__*/createElement("path", {
  d: "M35,37c0-1,0.3-2,0.9-3c0.6-1,1.5-1.8,2.7-2.5c1.2-0.7,2.6-1,4.2-1c1.5,0,2.8,0.3,3.9,0.8c1.1,0.6,2,1.3,2.6,2.2 c0.6,0.9,0.9,2,0.9,3.1c0,0.9-0.2,1.6-0.5,2.3c-0.4,0.7-0.8,1.2-1.3,1.7c-0.5,0.5-1.4,1.3-2.6,2.4c-0.3,0.3-0.6,0.6-0.8,0.8 c-0.2,0.2-0.4,0.5-0.5,0.7c-0.1,0.2-0.2,0.4-0.2,0.6c-0.1,0.2-0.1,0.6-0.3,1.1c-0.2,1.1-0.8,1.6-1.8,1.6c-0.5,0-1-0.2-1.4-0.5 c-0.4-0.3-0.5-0.9-0.5-1.6c0-0.9,0.1-1.6,0.4-2.2c0.3-0.6,0.6-1.2,1.1-1.7c0.4-0.5,1-1,1.8-1.7c0.7-0.6,1.1-1,1.4-1.3 c0.3-0.3,0.5-0.6,0.7-1c0.2-0.4,0.3-0.8,0.3-1.2c0-0.8-0.3-1.5-0.9-2.1c-0.6-0.6-1.4-0.8-2.4-0.8c-1.1,0-2,0.3-2.5,0.9 c-0.5,0.6-1,1.4-1.4,2.5c-0.3,1.2-1,1.7-2,1.7c-0.6,0-1.1-0.2-1.5-0.6C35.2,38,35,37.5,35,37z M42.6,54c-0.6,0-1.2-0.2-1.6-0.6 c-0.5-0.4-0.7-1-0.7-1.7c0-0.6,0.2-1.2,0.7-1.6c0.5-0.4,1-0.7,1.7-0.7c0.6,0,1.2,0.2,1.6,0.7c0.4,0.4,0.7,1,0.7,1.6 c0,0.7-0.2,1.3-0.7,1.7C43.7,53.7,43.2,54,42.6,54z"
}));
const Help = createSvg({
  name: 'help',
  path: HelpGlyph
});

export default Help;
export { HelpGlyph };
